export const FEATURE_EXAMPLE = 'ppark-xxxx-example-feature';
export const BAGGAGE_ASSISTANCE_NEAR_BAGS_MOBILE_NON_META = 'GUARD_GUARD2420_M';
export const BAGGAGE_ASSISTANCE_NEAR_BAGS_MOBILE_META =
  'GUARD_GUARD2420_M_META';
